import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DynamicFormDefinition, FormContainer, FormSubmission } from "../../../../common";
import { DependencyInjectionContext } from "../../../../contexts/dependency-injection-context";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../../../../authConfig";
import { AppBar, Button, IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoadingIndicator } from "../../../../components/core/LoadingIndicator/LoadingIndicator";

const FormSubmissionViewer = () => {
    const authRequest = {
        ...loginRequest
    };

    const { formsApi } = useContext(DependencyInjectionContext);
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);
    const [formDefinition, setFormDefinition] = useState<DynamicFormDefinition>();
    const [formSubmission, setFormSubmission] = useState<FormSubmission>();

    const getForm = async (id: string): Promise<DynamicFormDefinition> => {
        const form = await formsApi.fetchFormDefinition(id);
        return form;
    };

    const getFormSubmission = async (formSubmissionId: string): Promise<FormSubmission> => {

        let url = `FormSubmissionGet?formSubmissionId=${formSubmissionId}`;

        const response = await formsApi.get<FormSubmission>(url);
        return response;
    };

    const loadForm = async () => {
        if (id) {
            setLoading(true);

            const submission = await getFormSubmission(id);
            const definition = await getForm(submission.formDefinitionId);

            setFormDefinition(definition);
            setFormSubmission(submission);
            setLoading(false);
        }
    }

    const print = () => {
        window.print();
    }

    const navigateToSubmissions = () => {
        navigate("/forms/submissions");
    };

    useEffect(function effectFunction() {
        loadForm();
    }, [formsApi]);

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
        >
            <div className="page no-padding">
                <AppBar position="sticky" className="no-print">
                    <Toolbar>
                        <Tooltip title="Return to submissions">
                            <IconButton aria-label="return" onClick={navigateToSubmissions} className="menu-button">
                                <ArrowBackIcon />
                            </IconButton>
                        </Tooltip>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            {formDefinition?.name}
                        </Typography>
                        <Button color="inherit" onClick={print} endIcon={<PrintIcon />}>Print</Button>
                    </Toolbar>
                </AppBar>
                {formDefinition &&
                    <div style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20, pointerEvents: "none" }}>
                        <FormContainer form={formDefinition} hideSubmit={true} loading={false} formLoading={loading} formSubmission={formSubmission}></FormContainer>
                    </div>
                }
            </div>

            <LoadingIndicator loading={loading}></LoadingIndicator>
        </MsalAuthenticationTemplate>
    );
}


export default FormSubmissionViewer;